export interface StudentDeclarationsModel {
    declareIHaveBeenWithErasmusThisYear?: boolean;
    numberOfDaysWithErasmus?: number;
    declareIWantGrantDisadvantagedBackgrounds?: boolean;
    declareIWantGrantForSpecialNeeds?: boolean;
    isEmpty?: boolean;
}
